/**
 * Municipality page scripts.
 *
 * @module Municipality
 */

import CommonSubPage from './_CommonSubPage';

export default class News extends CommonSubPage {}



// WEBPACK FOOTER //
// ./src/js/pages/news.js